import {notify} from "@kyvg/vue3-notification";
import axios from "axios";

export default {
    namespaced: true,

    state: () => ({
        users: [],
        user: null,
        userId: null,
        userToken: null,
        totalUsers: null,
        userTrajectories: null,
        userActive:null,
        usersWhiteList: null,
        usersDeactivated:null,
        staffDepartments: [],
        parsedUsers: [],
        foundUsers: [],
        specialStaff: [],
        showBlocked: false,
        filters: {
            name: '',
            job_title: '',
            department: '',
            online_from: '',
            created_at: '',
            email: '',
            telephone: '',
            groups: [],
            current_group: null,
            without_group_only: false,
        },
        filterString: null,
        recentActivities: [],
        totalActivities: null,
        currentCourseActivity: [],
        currentCourseActivityTotal: null,
        staffWithProducts: [],
        staffWithProductsTotal: null,
    }),

    mutations: {
        setUser(state, data) {
            state.user = data;
        },
        setUsers(state, data) {
            state.users = data;
        },
        setUserId(state, data) {
            state.userId = data;
        },
        setUserToken(state, data) {
            state.userToken = data;
        },
        setTotalUsers(state, data) {
            state.totalUsers = data;
        },
        setUserTrajectories(state, data) {
            state.userTrajectories = data;
        },
        setUserStatusActive(state, data) {
            state.userActive = data;
        },
        setUsersWhiteList(state, data) {
            state.usersWhiteList = data;
        },
        setUsersDeactivated(state, data) {
            state.usersDeactivated = data;
        },
        setDepartments(state, data) {
            state.staffDepartments = data;
        },
        setParsedData(state, data) {
            state.parsedUsers = data;
        },
        setFoundUsers(state,data) {
            state.foundUsers = data;
        },
        setSpecialStaff(state, data) {
            state.specialStaff = data;
        },
        clearSpecialStaff(state) {
            state.specialStaff = null;
        },
        setShowBlocked(state) {
          state.showBlocked = true;
        },
        clearShowBlocked(state) {
            state.showBlocked = false;
        },
        clearParseData(state) {
            state.parsedUsers = null;
        },
        clearFoundUsers(state) {
            state.foundUsers = null;
        },
        setFilters(state, data) {
            state.filters = data.filters;
            state.filterString = data.filterString;
        },
        clearFilters(state) {
            state.filters = {
                name: '',
                job_title: '',
                department: '',
                online_from: '',
                created_at: '',
                email: '',
                telephone: '',
                groups: [],
                current_group: null,
                without_group_only: false,
            };
            state.filterString = null;
        },
        setRecentActivities(state, data) {
            state.recentActivities = data.data;
            state.totalActivities = data.total;
        },
        setCurrentCourseActivity(state, data) {
            state.currentCourseActivity = data.data;
            state.currentCourseActivityTotal = data.total;
        },
        setStaffWithProducts(state, data) {
            state.staffWithProducts = data.users;
            state.staffWithProductsTotal = data.total
        },
    },

    actions: {
        // eslint-disable-next-line no-unused-vars
        async createUser({commit}, data) {
            return axios.post(`/users`, data)
                .then((response) => {
                    if (response?.status === 422) {
                        return response;
                    }
                })
        },
        async getUser({commit}, id) {
            await axios.get(`/users/${id}`)
                .then(({data}) => {
                    commit("setUser", data)
                })
        },
        async getStaff({commit}, data) {
            await axios.post('/users/staffSearch', data)
                .then(({data}) => {
                    commit("setUsers", data.users)
                    commit("setTotalUsers", data.meta.total)
                })
        },
        async getStaffProducts({commit}, data) {
            await axios.post('/users/staff/products', data).then(({data}) => {
                commit("setStaffWithProducts", data)
            })
        },
        async getUsersBySearch({commit}, data) {
            data.email = encodeURIComponent(data.email);

            let url = `/users/staffSearch?per_page=${data.perPage}&page=${data.page}&name=${data.name}&email=${data.email}&role=${data.role}`;
            url += data.getDeactivated ? `&${data.getDeactivated}` : '';

            await axios.get(url)
                .then(({data}) => {
                    commit("setUsers", data.users)
                    commit("setTotalUsers", data.meta.total)
                })
        },
        async updateUser({commit}, data) {
            await axios.put(`/users/${data.id}`, data.form)
                .then((response) => {
                    if (response?.status === 422) {
                        return response;
                    } else {
                        commit("setUser", data)
                    }
                })
        },
        async getUserToken({commit}, id) {
            await axios.get(`/users/${id}/token`)
                .then(({data}) => {
                    commit("setUserToken", data)
                })
        },
        async getUserTrajectories({commit}, id) {
            await axios.get(`/users/${id}/trajectories`)
                .then(({data}) => {
                    commit("setUserTrajectories", data)
                })
        },
        async quotaAppend({commit}, data) {
            await axios.post(`/users/quota/append`, data)
                .then(({data}) => {
                    notify({
                        title: "Приглашение отправлено",
                        type: "success"
                    })
                })
        },
        async quotaRemove({commit}, data) {
            await axios.post(`/users/quota/remove`, data)
                .then(({data}) => {
                    notify({
                        title: "Приглашение отозвано",
                        type: "success"
                    })
                })
        },
        async setUserActive({commit}, data) {
            await axios.post(`/users/set/active`, { is_active: data.isActive, email: data.email })
                .then(({data}) => {
                    commit("setUserStatusActive", data)
                    notify({
                        title: "Данные сохранены",
                        type: "success"
                    });
                });
        },
        async resetStaffPassword({commit}, data) {
            await axios.post(`/users/password/reset`, data);
        },
        async getUsersWhiteList({commit}, data) {
            await axios.get(`/users/whiteList?date=` + (data?.date ?? ''))
                .then(({data}) => {
                    commit("setUsersWhiteList", data)
                });
        },
        async getUsersDeactivated({commit}, data) {
            await axios.get(`/users/deactivated?per_page=${data.perPage}&page=${data.page}&${data.sort ? data.sort : ''}`)
                .then(({data}) => {
                    commit("setUsersDeactivated", data.users)
                    commit("setTotalUsers", data.meta.total)
                })
        },
        async setStaffStatus({ commit }, data) {
            await axios.post('/users/set/status', data)
        },

        async sendStaffNotification({ commit }, data) {
            await axios.post('/users/notification/staff', data)
        },
        async getDepartments({ commit }, data) {
            await axios.get('/users/staff/departments')
                .then(({data}) => {
                    commit("setDepartments", data)
            });
        },
        async parseUsersFromExcel({ commit }, data) {
            await axios.post('/users/staff/parse_excel', data).then(({data}) => {
                commit("setParsedData", data)
            })
        },
        async searchByName({commit}, userName) {
            await axios.get('/users/search/' + userName).then(({data}) => {
                commit("setFoundUsers", data)
            })
        },
        async getUserActivities({commit}, data) {
            await axios.post('/users/' + data.userId + '/activities', data).then(({data}) => {
                commit("setRecentActivities", data)
            })
        },
        async getCourseActivity({commit}, data) {
            await axios.post('/courses/current_activity', data).then(({data}) => {
                commit("setCurrentCourseActivity", data)
            })
        },
        async updateRole({commit}, data) {
            await axios.post('/users/role/update', data);
        },
        setSpecialStaff({commit}, data) {
           commit('setSpecialStaff', data);
        },
        clearSpecialStaff({commit}) {
            commit('clearSpecialStaff')
        },
        setShowBlocked({commit}) {
            commit('setShowBlocked');
        },
        clearShowBlocked({commit}) {
            commit('clearShowBlocked')
        },
        clearParsedUsers({commit}) {
            commit('clearParseData');
        },
        clearFoundUsers({commit}) {
            commit('clearFoundUsers');
        },
        setUserFilters({commit}, data) {
            commit('setFilters', data)
        },
        clearUserFilters({commit}) {
            commit('clearFilters');
        }
    }
}
